// src/redux/thunks/planThunks.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'src/api/axiosInstance';

export const fetchPlanFeatures = createAsyncThunk(
  'plan/fetchFeatures',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/rest/plan/features');
      return response.data;
    } catch (err) {
      console.error('[PlanFeatures] Failed to fetch plan features:', err);
      return rejectWithValue(err?.response?.data?.message || 'Failed to fetch plan features');
    }
  }
);
